import { css } from "@emotion/css"
import { useI18n } from "providers/I18n"
import { endOfMonth, startOfMonth, startOfYear } from "date-fns"

import { useLocationSearch } from "hooks/useLocationSearch"
import { Options } from "components/inputs/Options"

import { serialize } from "./dates"

const styles = {
  select: css`
    width: 120px;
  `,
  input: css`
    border: 1px solid var(--disabled-grey);
    padding: revert;
  `,
}

const quarters = ["Q1", "Q2", "Q3", "Q4"] as const

type Quarter = (typeof quarters)[number]

const quarters_options = quarters.map((x) => ({
  value: x,
  label: x,
}))

const getQuarterBounds = (m1: number, m2: number): [Date, Date] => {
  const d1 = new Date().setMonth(m1)
  const d2 = new Date().setMonth(m2)
  return [startOfMonth(d1), endOfMonth(d2)]
}

const getRangeFromQuarter = (q: Quarter): [Date, Date] => {
  switch (q) {
    case "Q1": {
      return getQuarterBounds(0, 2)
    }
    case "Q2": {
      return getQuarterBounds(3, 5)
    }
    case "Q3": {
      return getQuarterBounds(6, 8)
    }
    case "Q4": {
      return getQuarterBounds(9, 11)
    }
  }
}

export function QuartersFilter() {
  const { t } = useI18n()
  const empty_option = [{ label: t("options.any"), value: "" }]
  const ls = useLocationSearch()

  const q = ls.get("q", "")!
  const onChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = evt?.target
    const v = value
    ls.set("q", v ?? "")
    if (v) {
      const [s, e] = getRangeFromQuarter(v as Quarter)
      ls.set("startDate", serialize(s))
      ls.set("endDate", serialize(e))
    } else {
      ls.set("startDate", serialize(startOfYear(new Date())))
      ls.set("endDate", serialize(new Date()))
    }
  }

  return (
    <Options
      name="quarter"
      label={t("filters.quarter")}
      options={empty_option.concat(quarters_options)}
      value={q}
      onChange={onChange}
      className={styles.select}
      inputClass={styles.input}
      margin="none"
      size="small"
      fullWidth
    />
  )
}
